import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import ReactTimeout from 'react-timeout';
import PropTypes from 'prop-types';
import _ from 'lodash';
import VideoContainer from 'components/VideoContainer';
import classNames from 'classnames';
import {
  Events,
  fireFloodlightEvent,
  getSegmentAnonymousId,
  getSegmentSourceName,
  getSegmentSourceType,
  handleAnalytics,
  OptimizelyPlayerTypes,
  trackPageReferrerAnalytics,
} from '@foxcorp/delta-web-analytics';
import { setRecommendationIdAction as setRecommendationId } from 'index/AppActions';
import {
  forceKeyartForShowcase as forceCollectionKeyartForShowcase,
  updateShowcaseVideo,
} from 'screens/Collection/Actions';
import { getDmaFromVideo } from 'helpers/AuthHelper';
import Video from 'components/VideoPlayer';
import PopUpModal from 'components/PopUpModal';
import { PopIn } from 'images';
import {
  isAMobileDevice,
  isMobileBreakpoint,
  SITE_PLATFORM_MOBILE,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
} from 'helpers/BreakpointHelper';
import {
  getLocation,
  helperGetHomeUrl,
  helperGoToRelativeUrl,
  helperGetLiveUrl,
} from 'helpers/RouteHelper';
import {
  checkAdBlocker,
  getAuthForPanelVideo,
  getAuthorizingNetwork,
  getNetworkList,
  getRequiresAuth,
  isClip,
  isEpisode,
  isLive,
} from 'helpers/ContentHelper';
import { noop } from 'helpers/GlobalHelper';
import {
  CONTINUOUS,
  PLAYER_REFERENCE_GLOBAL,
  getPlayerCsid,
  isPlayerTypeHero,
  isPreviewPass,
  PLAYER_CONTEXT_LIVE,
  PLAYER_CONTEXT_WATCH,
  playerRemove,
  playerSetUserActive,
  PLAYLIST,
  RESTART,
  updatePlayerType,
  getPercentComplete,
} from 'helpers/PlayerHelper';
import {
  RELEASE_TYPE_LIVE,
  RESTART_TYPE_LIVE,
  VIDEO_TYPE_CLIP,
  VIDEO_TYPE_FULLEPISODE,
  VIDEO_TYPE_MOVIE,
  VIDEO_TYPE_GAME,
} from 'screens/Watch/WatchHelpers';
import { isEpgv2Enabled } from 'helpers/ConfigHelper';
import { determineBrowser } from '../Header/HeaderHelpers';
import {
  clearNextVideosValidFor,
  clearPercentWatched,
  clearVideo,
  fetchNextVideo,
  fetchUpNext,
  fetchVideo,
  fetchVideoPanel,
  playNextPlaylistVideo,
  resetVodSectionClicked,
  saveLiveRestart,
  savePercentWatched,
  setError,
  setVideoCountdown,
  setHasSeenHalfAnyVideo,
  setMiniPlayerActive,
  setPortalContentFinished,
  setStreamExit,
  setVideoPanel,
  setVideoStartedPlayback,
} from './Actions';
import {
  getShouldCheckPreviewPass,
  getShouldDisablePreviewPassRender,
  getVideoContainerTheme,
} from './Helper';
import { DynamicRating, LiveContext, WatchContext } from './components';
import defaultStyle from './VideoPlayerGlobal.module.scss';
import heroStyle from './VideoPlayerGlobalHero.module.scss';

const Draggable = React.lazy(() => import('react-draggable'));

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    suppressNetworkIcon: false,
    playerMetadataOverlay: true,
  },
  [SITE_PLATFORM_WEB]: {
    suppressNetworkIcon: false,
    playerMetadataOverlay: true,
  },
  [SITE_PLATFORM_TABLET]: {
    suppressNetworkIcon: false,
    playerMetadataOverlay: false,
  },
  [SITE_PLATFORM_MOBILE]: {
    suppressNetworkIcon: false,
    playerMetadataOverlay: false,
  },
};
const CONTAINER_ID = 'video-player-container';
const PAGE_ROOT_ID = 'live-page-overflow';

const BOTTOM_RIGHT = 'br';
const TOP_RIGHT = 'tr';
const BOTTOM_LEFT = 'bl';
const TOP_LEFT = 'tl';

let autoplayTimeout;
let exitStreamTimeout;

class VideoPlayerGlobal extends Component {
  constructor(props) {
    super(props);
    const mode = _.get(this.props, 'params.modeId', '');
    const hash = _.trim(_.get(this.props, 'location.hash'), '#');
    const isRestart = mode === RESTART || _.includes(hash, RESTART);
    const isContinuous = _.includes(hash, CONTINUOUS);
    const isPlaylist = _.includes(hash, PLAYLIST);
    const playlistId = isPlaylist ? hash.replace(`${PLAYLIST}=`, '') : null;
    const playerType = _.get(this.props, 'playerType');
    const theme = isPlayerTypeHero(playerType) ? heroStyle : defaultStyle;

    this.state = {
      adPlaying: false,
      adPodStarted: null,
      clickedEndSlate: false,
      clickedThumbnail: false,
      continuous: isContinuous || isPlaylist,
      continuousPlayback: true,
      creditsPlaying: false,
      entitlementIssues: null,
      firePlayerPageViews: false,
      firstAdPlayed: false,
      firstFramePlayed: false,
      isAutoPlay: null,
      isBrowser: '',
      isAuthError: null,
      isVideoOverlayPresent: false,
      isAdBlockerEnabled: false,
      isPopUpModalVisible: false,
      mediaComplete: false,
      mediaEnding: false,
      mediaEndingSeconds: null,
      mediaStarted: false,
      miniPosition: {
        controlledPosition: { x: 0, y: 0 },
        corner: '',
      },
      playerDataHover: false,
      playerLoading: false,
      preAuthCheckComplete: false,
      segmentReferrer: null,
      segmentSourceName: null,
      segmentSourceType: null,
      showControls: true,
      showRestartOverlay: false,
      streamExit: false,
      containerId: CONTAINER_ID,
      popUpModalButtonText: null,
      popUpModalMessage: null,
      playlist: playlistId,
      restart: isRestart,
      showTVRating: false,
      showEndCards: true,
      showTrailerUpsell: false,
      stillWatchingHideTimeout: null,
      stillWatchingShowTimeout: null,
      theme,
      userClosedMiniPlayer: false,
    };

    this.playerRef = React.createRef();
    this.handleScroll = _.throttle(this.handleScroll, 16);
    this.handleResize = _.throttle(this.handleResize, 300);
    this.trackPageReferrerAnalytics = trackPageReferrerAnalytics.bind(this);
  }

  componentDidMount() {
    const root = document.getElementById(PAGE_ROOT_ID);
    const isBrowser = determineBrowser();
    this.setState({ isBrowser });
    if (root) {
      root.addEventListener('scroll', this.handleScroll, { passive: true });
    }
    checkAdBlocker().then(isAdBlockerEnabled => this.setState({ isAdBlockerEnabled }));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { clickedEndSlate, clickedThumbnail } = this.state;
    const {
      clearPercentWatched,
      errors,
      panelVideo,
      originalItem,
      resetVodSectionClicked,
      restartVideo,
      video,
    } = this.props;
    const {
      errors: nextErrors,
      panelVideo: nextPanelVideo,
      originalItem: nextOriginalItem,
      restartVideo: nextRestartVideo,
      video: nextVideo,
    } = nextProps;
    const videoId = _.get(video, 'id');
    const nextVideoId = _.get(nextVideo, 'id');
    let newState = {};

    if (nextOriginalItem && nextOriginalItem !== originalItem) {
      resetVodSectionClicked();
      this.triggerSegmentPlayerSectionSource({ originalItem: nextOriginalItem });
    }

    if (videoId && videoId !== nextVideoId) {
      newState.prevVideo = video;
      newState.adPlaying = false;
      newState.showControls = true;
      /*
       * setting showEndCards to false so that upNext Videos won't be visible with new next videos CPEWEB-4506
       */
      newState.showEndCards = false;
      if (!clickedEndSlate && !clickedThumbnail) {
        const analyticsLocation = getLocation(window.referrer);
        const { pathname: path } = analyticsLocation;
        const newSegmentSourceType = getSegmentSourceType({
          homeUrl: helperGetHomeUrl(),
          path,
          vodThumbnails: clickedThumbnail,
        });
        const segmentSourceName = getSegmentSourceName({
          data: video,
          type: newSegmentSourceType,
        });
        newState = {
          ...newState,
          segmentSourceName,
          segmentSourceType: newSegmentSourceType,
        };
      }
    }

    if (nextErrors !== errors) {
      newState.entitlementIssues = nextErrors && _.isArray(nextErrors) ? nextErrors : null;
      this.handlePopInMiniPlayer();
    }

    const screenUrl = this.getScreenUrl(panelVideo);
    const nextScreenUrl = this.getScreenUrl(nextPanelVideo);
    const screenUrlChanged = screenUrl && screenUrl !== nextScreenUrl;
    const restartVideoChanged = restartVideo !== nextRestartVideo;
    if (screenUrlChanged || restartVideoChanged) {
      newState.preAuthCheckComplete = false;
    }
    const panelVideoId = _.get(panelVideo, 'id');
    const nextPanelVideoId = _.get(nextPanelVideo, 'id');
    if (panelVideoId !== nextPanelVideoId) clearPercentWatched();

    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      accessToken,
      authSuccess,
      clearTimeout,
      clearVideo,
      deviceId,
      errors,
      fetchVideo,
      forceCollectionKeyartForShowcase,
      isLivePage,
      isMiniPlayerActive,
      isPlayerLoaded,
      panelVideo,
      playerType,
      provider,
      setTimeout,
      setVideoStartedPlayback,
      startedPlayback,
      video,
    } = this.props;
    const {
      accessToken: prevAccessToken,
      authSuccess: prevAuthSuccess,
      errors: prevErrors,
      isLivePage: prevIsLivePage,
      isMiniPlayerActive: prevMiniPlayerActive,
      startedPlayback: prevStartedPlayback,
      playerType: prevPlayerType,
      video: prevVideo,
    } = prevProps;
    const { isFullscreen, preAuthCheckComplete } = this.state;
    const {
      isFullscreen: prevIsFullscreen,
      preAuthCheckComplete: prevPreAuthCheckComplete,
    } = prevState;
    const isHeroPlayer = isPlayerTypeHero(playerType);
    const screenUrl = this.getScreenUrl(panelVideo);
    const mvpd = _.get(provider, 'adobePassId');
    const autoplayContent = _.get(panelVideo, 'autoplayContent');
    const mvpdIsValidForPlayback = isHeroPlayer ? !isPreviewPass(mvpd) : true;
    const preAuthCheckCompleteChanged = preAuthCheckComplete !== prevPreAuthCheckComplete;
    const authSuccessChanged = authSuccess !== prevAuthSuccess;
    const accessTokenChanged = accessToken !== prevAccessToken;
    const contentChanged = authSuccessChanged || preAuthCheckCompleteChanged || accessTokenChanged;
    const hasRequiredAuthData = preAuthCheckComplete && authSuccess && accessToken;
    const canFetchVideo = isHeroPlayer ? autoplayContent : true;
    const shouldFetchVideo =
      screenUrl && hasRequiredAuthData && contentChanged && mvpdIsValidForPlayback;
    const setAutoplayTimeout = !prevStartedPlayback && startedPlayback && isHeroPlayer;
    const playerTypeChanged = playerType !== prevPlayerType && playerType;
    const videoCleared = prevVideo && !video;

    const fullScreenChanged = isFullscreen !== prevIsFullscreen;
    const isErrors = errors !== prevErrors;
    const miniPlayerActiveChanged = prevMiniPlayerActive !== isMiniPlayerActive;

    let nextState = {};

    if (!isAMobileDevice() && isLivePage && isMiniPlayerActive) {
      window.addEventListener('resize', this.handleResize, { passive: true });
    } else window.removeEventListener('resize', this.handleResize);

    if (isLivePage !== prevIsLivePage) {
      this.handlePopInMiniPlayer({ isRemount: true });
    }

    if ((miniPlayerActiveChanged && isErrors) || fullScreenChanged) {
      this.handlePopInMiniPlayer();
    }

    if (playerTypeChanged) {
      updatePlayerType(playerType, PLAYER_REFERENCE_GLOBAL);
      const nextTheme = isHeroPlayer ? heroStyle : defaultStyle;
      const clearAutoplayTimeout = isPlayerTypeHero(prevPlayerType) && !isHeroPlayer;
      if (clearAutoplayTimeout) clearTimeout(autoplayTimeout);
      nextState = {
        ...nextState,
        theme: nextTheme,
      };
    }

    if (setAutoplayTimeout) {
      const { autoplayIdleLimitSeconds } = window.ExternalConfig;
      if (autoplayIdleLimitSeconds) {
        const timeoutInMilliseconds = autoplayIdleLimitSeconds * 1000;
        clearTimeout(autoplayTimeout);
        autoplayTimeout = setTimeout(() => {
          forceCollectionKeyartForShowcase(true);
          clearVideo();
        }, timeoutInMilliseconds);
      }
    }

    if (shouldFetchVideo) {
      setVideoStartedPlayback(false);
      if (canFetchVideo) {
        const panelType = _.get(panelVideo, '@type');
        const videoGuid = _.get(panelVideo, 'guid');
        const audioOnly = _.get(panelVideo, 'audioOnly');
        const isLivePanel = isLive(panelType);
        const hash = _.trim(_.get(this.props, 'location.hash'), '#');
        const isPlaylist = _.includes(hash, PLAYLIST);
        const newPlaylistId = isPlaylist ? hash.replace(`${PLAYLIST}=`, '') : null;
        const { playlist } = prevState;
        let newScreenUrl = screenUrl;
        if (screenUrl && newPlaylistId && playlist !== newPlaylistId) {
          const prependCharacter = screenUrl.includes('?') ? '&' : '?';
          newScreenUrl = `${screenUrl}${prependCharacter}${PLAYLIST}=${newPlaylistId}`;
          nextState = { ...nextState, playlist: newPlaylistId };
        }

        const options = {
          url: newScreenUrl,
          isLive: isLivePanel,
          accessToken,
          deviceId,
          videoGuid,
          audioOnly,
          panelVideo,
        };
        fetchVideo(options);
      }
    }

    if ((shouldFetchVideo || videoCleared) && !isPlayerLoaded) {
      nextState = {
        ...nextState,
        creditsPlaying: false,
        firstFramePlayed: false,
        isAuthError: false,
        mediaComplete: false,
        mediaEnding: false,
        mediaEndingSeconds: null,
        playerLoading: true,
      };
    }
    this.setUserAtrribute50PercentViewed(video, PLAYER_REFERENCE_GLOBAL);

    if (!_.isEmpty(nextState)) this.setState(nextState);
  }

  componentWillUnmount() {
    const root = document.getElementById(PAGE_ROOT_ID);
    if (root) {
      root.removeEventListener('scroll', this.handleScroll);
    }
    const { clearVideo } = this.props;
    clearVideo();
    this.clearTimeouts();
  }

  onExitEventStream = e => {
    const { setTimeout } = this.props;
    const timeout = _.get(e, 'exitEventStreamSlateDuration', 30);
    exitStreamTimeout = setTimeout(() => {
      this.setState({ streamExit: true });
    }, timeout * 1000);
  };

  getDefaultPlayerEvents = () => ({
    onPlayerLoadComplete: () => {
      const { isAuthError: lclIsAuthError } = this.state;
      this.setState({ playerLoading: false });
      if (lclIsAuthError) playerRemove(PLAYER_REFERENCE_GLOBAL);
    },
    onShowControls: e => {
      const { showControls: oldShowControls, isAuthError: lclIsAuthError } = this.state;

      if (oldShowControls !== e && !lclIsAuthError) {
        this.setState({ showControls: e });
      }
    },
    onReleaseCleared: e => {
      const { clearVideo, forceCollectionKeyartForShowcase, playerType } = this.props;
      const { reason } = e;
      const isPlayerHero = isPlayerTypeHero(playerType);
      if (reason === 'concurrency' && isPlayerHero) {
        forceCollectionKeyartForShowcase(true);
        clearVideo();
        this.clearTimeouts();
      } else if (e) this.setState({ isVideoOverlayPresent: true });
    },
    // TODO: move to live context
    onExitEventStream: e => {
      this.onExitEventStream(e);
    },
  });

  getDefaultVideoContainerProps = item => {
    const {
      adPlaying,
      entitlementIssues,
      playerLoading,
      showControls,
      showTrailerUpsell,
      stickyControls,
      playerDataHover,
    } = this.state;
    const {
      accessToken,
      account,
      adblock,
      anonymousId,
      anonymousLogin,
      authSuccess,
      blackoutConfig,
      blackoutDefinitions,
      breakpoint,
      deviceId,
      isLiveRestart,
      isStatic,
      isVodUnavailable,
      mvpdData,
      onAuthCheckComplete,
      panelVideo,
      playerType,
      preauthorizedResources,
      profileId,
      provider,
      releaseUrl,
      renderAuthContainer,
      setAuthorizationToken,
      setBlockMVPDIncomplete,
      setInterval,
      setIsAuthenticated,
      setIsPlayerLoaded,
      setMVPDLogoutDataToAppState,
      setMVPDToAppState,
      setOverlay,
      setProvider,
      toggleMvpdAuthOverlay,
      triggerAuthCheck,
      video,
    } = this.props;

    if (!item)
      return { breakpoint, renderAuthContainer, theme: getVideoContainerTheme(playerType) };

    const {
      scrubbingEnabled,
      videoType,
      contentRating,
      contentSKU,
      id: videoId,
      network,
      networks,
      showCode,
    } = item;
    const shouldShowControls = showControls || stickyControls || playerDataHover;
    const siteSection = getPlayerCsid({
      showCode,
      isFullEpisode: isEpisode(videoType),
    });
    const requiresAuth = getRequiresAuth({ video: panelVideo });
    const requiresAuthLive = getRequiresAuth({ video: panelVideo, isLive: true });
    const networkEntitlementList = getNetworkList();
    const authorizingNetwork = getAuthorizingNetwork(item, false, accessToken);
    const contentNetworks = networks || [network];
    const isClip = videoType === VIDEO_TYPE_CLIP;
    const scrubbingEnabledCalc = scrubbingEnabled || isClip;
    const containerClass = null;
    const shouldCheckPreviewPass = getShouldCheckPreviewPass(playerType);
    const disablePreviewPassRender = getShouldDisablePreviewPassRender(playerType);
    const props = {
      account,
      adblock,
      anonymousId,
      anonymousLogin,
      authSuccess,
      authorizingNetwork,
      backfade: (showControls || playerDataHover) && !adPlaying,
      blackoutConfig,
      blackoutDefinitions,
      breakpoint,
      containerClass,
      contentNetworks,
      contentRating,
      contentSKU,
      deviceId,
      entitlementIssues,
      isLiveRestart,
      isStatic,
      isVodUnavailable,
      mvpdData,
      network,
      networkEntitlementList,
      onAuthCheckComplete,
      playerLoading,
      playerType,
      preauthorizedResources,
      profileId,
      profileToken: accessToken,
      provider,
      reducerVideo: video,
      releaseURL: releaseUrl,
      renderAuthContainer,
      requiresAuth,
      requiresAuthLive,
      scrubbingEnabled: scrubbingEnabledCalc,
      selectedVideo: videoId,
      setAuthError: value => this.setState({ isAuthError: value }),
      setAuthorizationToken,
      setBlockMVPDIncomplete,
      setInterval,
      setIsAuthenticated,
      setIsPlayerLoaded,
      setMVPDLogoutDataToAppState,
      setMVPDToAppState,
      setOverlay,
      setPlayerDataHover: this.setPlayerDataHover,
      setPreAuthCheckComplete: this.setPreAuthCheckComplete,
      setProvider,
      setStickyControls: this.setStickyControls,
      showTrailerUpsell,
      shouldCheckPreviewPass,
      disablePreviewPassRender,
      showControls: shouldShowControls,
      siteSection,
      theme: getVideoContainerTheme(playerType),
      toggleMvpdAuthOverlay,
      triggerAuthCheck,
      videoId,
      videoType,
    };
    return props;
  };

  getScreenUrl = item => {
    const { playlist } = this.state;
    const { isLiveRestart } = this.props;

    const isLiveContent = this.isLiveContent(item) && !isLiveRestart;
    const screenUrlPath = isLiveContent ? 'livePlayerScreenUrl' : 'playerScreenUrl';
    let screenUrl = _.get(item, screenUrlPath);
    if (playlist && screenUrl) {
      const prependCharacter = screenUrl.includes('?') ? '&' : '?';
      const playlistParam = `${prependCharacter}${PLAYLIST}=${playlist}`;
      screenUrl = `${screenUrl}${playlistParam}`;
    }
    return screenUrl;
  };

  setPopUpModal = ({ visibility, message, buttonText }) => {
    this.setState({
      isPopUpModalVisible: visibility,
      popUpModalMessage: message,
      popUpModalButtonText: buttonText,
    });
  };

  setPlayerDataHover = hover => {
    const { breakpoint } = this.props;
    const { playerMetadataOverlay } = BREAKPOINTS[breakpoint];
    if (playerMetadataOverlay) {
      this.setState({ playerDataHover: hover }, () => {
        this.setStickyControls(hover);
      });
    }
  };

  setPlayerState = (newState, cb) => {
    if (newState) this.setState(newState, cb);
  };

  setPreAuthCheckComplete = (value = true) => {
    this.setState({ preAuthCheckComplete: value });
  };

  setStickyControls = sticky => {
    const { playerDataHover } = this.state;
    this.setState({ stickyControls: sticky }, () => {
      playerSetUserActive(PLAYER_REFERENCE_GLOBAL, sticky || playerDataHover);
    });
  };

  setVideoOverlay = overlay => {
    this.setState({ isVideoOverlayPresent: overlay });
  };

  setUserAtrribute50PercentViewed = (video, playerReference) => {
    const { hasSeenHalfAnyVideo, setHasSeenHalfAnyVideo } = this.props;
    const { videoType = '', durationInSeconds } = video || {};
    if (!hasSeenHalfAnyVideo && !isClip(videoType)) {
      const percentComplete = getPercentComplete({ playerReference, durationInSeconds });
      if (percentComplete && percentComplete >= 50) setHasSeenHalfAnyVideo();
    }
  };

  clearTimeouts = () => {
    const { clearTimeout } = this.props;
    clearTimeout(autoplayTimeout);
    clearTimeout(exitStreamTimeout);
  };

  floodlightEvent = videoData => {
    const isLongForm = !isClip(_.get(videoData, 'videoType', ''));
    fireFloodlightEvent(videoData, isLongForm);
  };

  gotoLive = () => {
    const hash = _.trim(_.get(this.props, 'location.hash'), '#');
    const callSign = _.trim(hash.replace(RESTART_TYPE_LIVE, ''), '-');
    helperGoToRelativeUrl(helperGetLiveUrl({ callSign }));
  };

  isLiveContent = item => isLive(_.get(item, '@type'));

  triggerSegmentPlayerSectionSource = ({ originalItem } = {}) => {
    const originalItemId = _.get(originalItem, 'id');
    const currentId = _.get(this.props, 'video.id');
    if (originalItemId === currentId) return null;
    const {
      firstFramePlayed,
      segmentSourceType,
      segmentSourceName,
      mediaComplete,
      clickedThumbnail,
    } = this.state;
    if (firstFramePlayed && !mediaComplete) {
      const { video } = this.props;
      let newSegmentSourceName = segmentSourceName;
      let newSegmentSourceType = segmentSourceType;
      if (!newSegmentSourceName || !newSegmentSourceType) {
        const analyticsLocation = getLocation(window.referrer);
        const { pathname: path } = analyticsLocation;
        newSegmentSourceType = getSegmentSourceType({
          homeUrl: helperGetHomeUrl(),
          path,
          vodThumbnails: clickedThumbnail,
        });
        newSegmentSourceName = getSegmentSourceName({
          data: video,
          type: newSegmentSourceType,
        });
      }
    }
    return this.setState({ clickedThumbnail: originalItem });
  };

  renderDynamicRating = video => {
    if (!video) return null;

    const { showTVRating, playerLoading, adPlaying } = this.state;
    const { contentRating, releaseType, subRatings, showTvRatingOverlay, videoType } = video;
    const isLiveVideo = this.isLiveContent(video);

    if (!contentRating) return null;

    const shouldDisplayOverlayVOD = () => {
      const videoTypes = [VIDEO_TYPE_FULLEPISODE, VIDEO_TYPE_MOVIE, VIDEO_TYPE_GAME];
      const validVideoType = videoType && videoTypes.indexOf(videoType) !== -1;
      const isNotLive = releaseType !== RELEASE_TYPE_LIVE;
      return !!(showTVRating && showTvRatingOverlay && validVideoType && isNotLive);
    };

    const shouldDisplayOverlayLive = () =>
      !!(isLiveVideo && showTvRatingOverlay && !playerLoading && !adPlaying);

    const shouldDisplayOverlay = isLiveVideo
      ? shouldDisplayOverlayLive()
      : shouldDisplayOverlayVOD();
    if (!shouldDisplayOverlay) return null;
    return <DynamicRating rating={contentRating} subRatings={subRatings} />;
  };

  // mini player
  setMiniPlayer = () => {
    const { setMiniPlayerActive } = this.props;
    setMiniPlayerActive(true);
    this.handlePositionUpdate('br');
  };

  clearMiniPlayer = () => {
    const { setMiniPlayerActive } = this.props;
    setMiniPlayerActive(false);
    this.setState({
      miniPosition: {
        controlledPosition: null,
        corner: null,
      },
    });
  };

  setMiniPosition = ({ x, y, corner }) => {
    this.setState({
      miniPosition: {
        controlledPosition: {
          x,
          y,
        },
        corner,
      },
    });
  };

  handleDrag = e => {
    const { clientX: x, clientY: y } = e;
    const { isMiniPlayerActive } = this.props;
    const body = document.querySelector('body');
    const { clientWidth: w, clientHeight: h } = body;

    if (body && isMiniPlayerActive) {
      if (x >= w / 2 && y >= h / 2) {
        this.handlePositionUpdate(BOTTOM_RIGHT);
      } else if (x >= w / 2 && y < h / 2) {
        this.handlePositionUpdate(TOP_RIGHT);
      } else if (y >= h / 2 && x < w) {
        this.handlePositionUpdate(BOTTOM_LEFT);
      } else if (y <= h / 2 && y < h / 2) {
        this.handlePositionUpdate(TOP_LEFT);
      }
    }
  };

  handlePositionUpdate = pos => {
    if (this.playerRef.current) {
      const body = document.querySelector('body');
      const { clientWidth: width, clientHeight: height } = this.playerRef.current;

      let position;

      switch (pos) {
        case BOTTOM_RIGHT:
          position = {
            x: body.clientWidth - width - 30,
            y: body.clientHeight - height - 10,
            corner: pos,
          };
          break;
        case TOP_RIGHT:
          position = {
            x: body.clientWidth - width - 30,
            y: 10,
            corner: pos,
          };
          break;
        case BOTTOM_LEFT:
          position = {
            x: 10,
            y: body.clientHeight - height - 10,
            corner: pos,
          };
          break;
        case TOP_LEFT:
          position = {
            x: 10,
            y: 10,
            corner: pos,
          };
          break;
        default:
          position = { x: 0, y: 0, corner: pos };
      }

      this.setMiniPosition(position);
    }
  };

  handleResize = () => {
    if (isAMobileDevice()) return;
    const { isMiniPlayerActive } = this.props;
    const {
      miniPosition: { corner },
    } = this.state;

    if (isMiniPlayerActive && window.innerWidth < 768) {
      this.handlePopInMiniPlayer();
    }

    if (isMiniPlayerActive) {
      this.handlePositionUpdate(corner);
    }
  };

  handleScroll = () => {
    if (isAMobileDevice()) return;
    const {
      isMiniPlayerActive,
      appRef: { current },
      errors,
    } = this.props;
    const { userClosedMiniPlayer } = this.state;

    const player = window.player?.global?.videoElement;
    const { clientHeight: playerHeight } = this.playerRef?.current ?? {};

    if (player && current) {
      if (player.readyState >= 2 && player.currentTime > 0 && !player.ended) {
        if (!errors && !isMiniPlayerActive && !userClosedMiniPlayer) {
          if (current.scrollTop > playerHeight && window.innerWidth > 768) {
            this.setMiniPlayer();
          }
        } else if ((isMiniPlayerActive || userClosedMiniPlayer) && current.scrollTop === 0) {
          this.handlePopInMiniPlayer();
        }
      }
    }
  };

  getOptimizelyAttributesUserId = () => {
    const { optimizely } = this.props;
    const userId = getSegmentAnonymousId();
    const {
      page_url,
      is_debug_build,
      device_type,
      browser_name_version,
    } = optimizely?.user?.attributes;
    const attributes = {
      page_url,
      is_debug_build,
      device_type,
      browser_name_version,
    };
    return {
      attributes,
      optimizely,
      userId,
    };
  };

  handleOnClickPipButton = () => {
    this.setMiniPlayer();
  };

  handleOnClickNativePipButton = () => {
    handleAnalytics({
      event: Events.PLAYER_SCREEN_LAYOUT_CHANGED,
      payload: {
        page_url: window.location.href,
        player_type: OptimizelyPlayerTypes.NATIVE_MINI_PLAYER,
        segment_anonymous_id: getSegmentAnonymousId(),
      },
    });
  };

  handlePopInButtonClick = () => {
    this.handlePopInMiniPlayer();
  };

  handlePopInMiniPlayer = ({ isRemount = false } = {}) => {
    const root = document.getElementById(PAGE_ROOT_ID);
    root.scrollTop = 0;
    this.clearMiniPlayer();

    if (!isRemount) {
      handleAnalytics({
        event: Events.PLAYER_SCREEN_LAYOUT_CHANGED,
        payload: {
          page_url: window.location.href,
          player_type: OptimizelyPlayerTypes.MAIN_PLAYER,
          segment_anonymous_id: getSegmentAnonymousId(),
        },
      });
    }
  };

  handleCloseMiniPlayer = () => {
    handleAnalytics({
      event: Events.PLAYER_SCREEN_LAYOUT_CHANGED,
      payload: {
        page_url: window.location.href,
        player_type: OptimizelyPlayerTypes.MAIN_PLAYER,
        segment_anonymous_id: getSegmentAnonymousId(),
      },
    });

    this.clearMiniPlayer();
    this.setState({
      userClosedMiniPlayer: true,
    });
  };

  removeEventListeners = () => {
    const root = document.getElementById(PAGE_ROOT_ID);
    if (root) root.removeEventListener('scroll', this.handleScroll);
  };

  renderPlayer = () => {
    const {
      accessToken,
      authSuccess,
      countdownVideo,
      errors,
      onChannelSelect,
      isLivePage,
      isMiniPlayerActive,
      optimizelyResults,
      page,
      panelVideo,
      playerContext,
      portalRef,
      retryErrors,
      video,
    } = this.props;
    const {
      isFullscreen,
      isAdBlockerEnabled,
      miniPosition: { controlledPosition },
      theme,
    } = this.state;

    const playerReference = PLAYER_REFERENCE_GLOBAL;
    const panelType = _.get(panelVideo, '@type');
    const isLivePanel = isLive(panelType);

    const requiresAuthLive =
      isLivePanel && getAuthForPanelVideo(panelVideo, isLivePanel, accessToken);
    const requiresAuthVod =
      !isLivePanel &&
      panelVideo?.requiresMVPDAuth &&
      getAuthForPanelVideo(panelVideo, isLivePanel, accessToken);
    if (panelVideo) {
      panelVideo.requiresAuthLive = requiresAuthLive;
      panelVideo.requiresAuth = requiresAuthVod;
    }

    const fetchedVideo = video || panelVideo;
    const defaultVideoContainerProps = this.getDefaultVideoContainerProps(fetchedVideo);
    const dma = getDmaFromVideo(panelVideo);
    const isContextPlayer =
      portalRef === 'context-player-video-portal' && document.getElementById(portalRef);

    const containerProps = {
      ...defaultVideoContainerProps,
      accessToken,
      authSuccess,
      countdownVideo,
      errors,
      onChannelSelect,
      dma,
      handlePopInMiniPlayer: this.handlePopInMiniPlayer,
      isFullscreen,
      isLivePage,
      isMiniPlayerActive,
      optimizelyResults,
      panelVideo,
      playerReference,
      portalRef,
      removeEventListeners: this.removeEventListeners,
      retryErrors,
      retryFetchVideo: () => {
        const { fetchVideo, accessToken, deviceId, panelVideo } = this.props;
        const screenUrl = this.getScreenUrl(panelVideo);
        const panelType = _.get(panelVideo, '@type');
        const videoGuid = _.get(panelVideo, 'guid');
        const audioOnly = _.get(panelVideo, 'audioOnly');
        const isLivePanel = isLive(panelType);
        fetchVideo({
          url: screenUrl,
          isLive: isLivePanel,
          accessToken,
          deviceId,
          videoGuid,
          audioOnly,
          panelVideo,
        });
      },
    };
    const renderVideoContainer = ({ props, endCards, videoDetail }) => (
      <VideoContainer {...containerProps} {...props} endCards={endCards} videoDetail={videoDetail}>
        <Video />
      </VideoContainer>
    );
    const dynamicRating = this.renderDynamicRating(fetchedVideo);
    const contextProps = {
      ...this.props,
      ...this.state,
      defaultPlayerEvents: this.getDefaultPlayerEvents(),
      fetchedVideo,
      floodlightEvent: this.floodlightEvent,
      handlePopInMiniPlayer: this.handlePopInMiniPlayer,
      isMiniPlayerActive,
      isAdBlockerEnabled,
      isContextPlayer,
      page,
      playerContext,
      playerReference,
      removeEventListeners: this.removeEventListeners,
      renderVideoContainer,
      setPopUpModal: this.setPopUpModal,
      setPlayerDataHover: this.setPlayerDataHover,
      setPlayerState: this.setPlayerState,
      setStickyControls: this.setStickyControls,
      isFullscreen,
      containerId: CONTAINER_ID,
    };

    if (!isAMobileDevice() && window.innerWidth > 768) {
      const player = document.querySelector('#video-player-global.jwplayer');
      const nativePipBtn = player?.querySelector('.pipButton');

      if (player && nativePipBtn) {
        if (isLivePage) {
          const miniPipBtn = document.createElement('button');

          miniPipBtn.classList.add('pip');
          miniPipBtn.addEventListener('click', this.handleOnClickPipButton);

          nativePipBtn.parentNode.replaceChild(miniPipBtn, nativePipBtn);
        } else if (nativePipBtn.getAttribute('clickListener') !== 'true') {
          nativePipBtn.addEventListener('click', this.handleOnClickNativePipButton);
          player.addEventListener('leavepictureinpicture', this.handleCloseMiniPlayer);

          nativePipBtn.setAttribute('clickListener', 'true');
        }
      }
    }

    let contextPlayer;
    switch (playerContext) {
      case PLAYER_CONTEXT_WATCH:
        contextPlayer = <WatchContext {...contextProps} />;
        break;
      case PLAYER_CONTEXT_LIVE:
        contextPlayer = <LiveContext {...contextProps} />;
        break;
      default:
        break;
    }

    return isLivePage ? (
      <React.Suspense fallback={<div />}>
        <Draggable
          bounds="body"
          disabled={!isMiniPlayerActive}
          handle=".handle"
          nodeRef={this.playerRef}
          onStop={this.handleDrag}
          position={isMiniPlayerActive ? controlledPosition : { x: 0, y: 0 }}
          scale={1}
        >
          <div
            ref={this.playerRef}
            className={classNames(
              'handle',
              isMiniPlayerActive ? defaultStyle.miniPlayer : defaultStyle.disableMiniPlayer,
              theme.videoContainerWrapper,
            )}
            id={CONTAINER_ID}
            onMouseEnter={() => this.setState({ stickyControls: true })}
            onMouseLeave={() => this.setState({ stickyControls: false })}
          >
            {dynamicRating}
            <div className={theme.shadowOverlay} />
            {contextPlayer}
            {!isFullscreen && (
              <>
                <div onClick={this.handlePopInButtonClick} className={defaultStyle.btnPopIn}>
                  <PopIn />
                </div>
                <button onClick={this.handleCloseMiniPlayer} className={defaultStyle.btnClose} />
                <button className={defaultStyle.btnPip} />
              </>
            )}
          </div>
        </Draggable>
      </React.Suspense>
    ) : (
      <div
        className={classNames(theme.videoContainerWrapper)}
        id={CONTAINER_ID}
        onMouseEnter={() => this.setState({ stickyControls: true })}
        onMouseLeave={() => this.setState({ stickyControls: false })}
      >
        {dynamicRating}
        <div className={theme.shadowOverlay} />
        {contextPlayer}
      </div>
    );
  };

  render() {
    const {
      breakpoint,
      disableRender,
      isLivePage,
      isMiniPlayerActive,
      playerType,
      portalRef,
      streamExit,
    } = this.props;
    const {
      firstFramePlayed,
      isAuthError,
      isBrowser,
      isPopUpModalVisible,
      popUpModalButtonText,
      popUpModalMessage,
      theme,
    } = this.state;
    const { oops_message_ad_block_failure: adBlockFailureText } = window.Language;
    const networksBar = window.ExternalConfig.networkNavigation;
    if (disableRender || streamExit) return null;
    const isMobile = isMobileBreakpoint(breakpoint);
    const hide = isPlayerTypeHero(playerType) && (!firstFramePlayed || isMobile || isAuthError);
    const hideContainerClass = hide && theme.hide;
    const videoPlayer = this.renderPlayer();
    const containerPaddingClass = networksBar ? theme.withNetworksBar : '';
    const isLiveMini = !isAMobileDevice() && isLivePage && isMiniPlayerActive;

    const handleOnclosePopUpModal = () => {
      const homeUrl = helperGetHomeUrl();
      this.setState({ isPopUpModalVisible: false });
      if (popUpModalMessage === adBlockFailureText) {
        helperGoToRelativeUrl(homeUrl);
      }
    };

    const videoPlayerGlobal = (
      <div
        className={classNames(
          isLiveMini && isBrowser !== 'safari'
            ? defaultStyle.miniPlayerActive
            : isLiveMini && defaultStyle.miniPlayerActiveSafari,
          theme.container,
          hideContainerClass,
          containerPaddingClass,
          isEpgv2Enabled() ? theme.resizablePlayer : null,
        )}
      >
        <PopUpModal
          message={popUpModalMessage}
          onClose={handleOnclosePopUpModal}
          visibility={isPopUpModalVisible}
          buttonText={popUpModalButtonText}
        />
        <div className={theme.overlay} />
        <div className={classNames(theme.innerContainer)}>{videoPlayer}</div>
      </div>
    );

    const portalLocation = document.getElementById(portalRef);
    return portalRef && portalLocation
      ? ReactDOM.createPortal(videoPlayerGlobal, portalLocation)
      : videoPlayerGlobal;
  }
}

function mapStateToProps({ globalVideo, app }) {
  const globalVideoProps = _.pick(globalVideo, [
    'countdownVideo',
    'onChannelSelect',
    'disableRender',
    'errors',
    'hasSeenHalfAnyVideo',
    'hideVideoUntilPlayback',
    'isLiveRestart',
    'isMiniPlayerActive',
    'isVodUnavailable',
    'nextVideo',
    'nextVideos',
    'nextVideosValidFor',
    'originalItem',
    'optimizelyResults',
    'page',
    'panelVideo',
    'playerContext',
    'playerType',
    'portalRef',
    'releaseUrl',
    'restartVideo',
    'retryErrors',
    'shouldResetStillWatching',
    'showControls',
    'startedPlayback',
    'streamExit',
    'video',
  ]);
  return {
    ...globalVideoProps,
    recommendationIdData: app.recommendationIdData,
  };
}

export default connect(mapStateToProps, {
  clearNextVideosValidFor,
  clearPercentWatched,
  clearVideo,
  fetchNextVideo,
  fetchUpNext,
  fetchVideo,
  fetchVideoPanel,
  forceCollectionKeyartForShowcase,
  playNextPlaylistVideo,
  resetVodSectionClicked,
  savePercentWatched,
  setError,
  setPortalContentFinished,
  setRecommendationId,
  setVideoPanel,
  setVideoStartedPlayback,
  saveLiveRestart,
  setMiniPlayerActive,
  setVideoCountdown,
  setStreamExit,
  updateShowcaseVideo,
  setHasSeenHalfAnyVideo,
})(ReactTimeout(VideoPlayerGlobal));

VideoPlayerGlobal.defaultProps = {
  accessToken: null,
  account: null,
  adblock: false,
  anonymousId: null,
  anonymousLogin: noop,
  authSuccess: false,
  blackoutConfig: null,
  blackoutDefinitions: null,
  clearTimeout: noop,
  coordinates: null,
  countdownVideo: {},
  deviceId: null,
  errors: null,
  favoritesManager: null,
  hasSeenHalfAnyVideo: false,
  isAuthenticated: false,
  isHeader: false,
  isHomePage: false,
  isLiveRestart: false,
  isLivePage: false,
  isNavScheduleRendered: false,
  isPlayerLoaded: false,
  isStatic: false,
  isVodUnavailable: false,
  location: {},
  mvpdData: null,
  nextVideosValidFor: null,
  onAuthCheckComplete: noop,
  onChannelSelect: noop,
  openSignIn: noop,
  openSignUp: noop,
  originalItem: {},
  optimizely: {},
  optimizelyResults: null,
  page: null,
  panelVideo: null,
  panels: {},
  params: {},
  playerContext: null,
  playerType: null,
  playlistData: null,
  portalRef: '',
  preauthorizedResources: [],
  profileId: null,
  provider: {},
  recommendationIdData: null,
  reducerVideo: null,
  releaseUrl: null,
  renderVideoContainer: null,
  restartVideo: null,
  retryErrors: {},
  seo: null,
  setAccountCloseIgnoreRedirect: noop,
  setBlockMVPDIncomplete: noop,
  setHasSeenHalfAnyVideo: noop,
  setInterval: noop,
  setIsAuthenticated: false,
  setIsPlayerLoaded: false,
  setLoading: null,
  setMVPDLogoutDataToAppState: noop,
  setMVPDToAppState: noop,
  setOverlay: false,
  setRecommendationId: noop,
  setTimeout: noop,
  shouldResetStillWatching: false,
  streamExit: false,
  toggleMvpdAuthOverlay: noop,
  triggerAuthCheck: false,
  video: null,
};

VideoPlayerGlobal.propTypes = {
  accessToken: PropTypes.string,
  appRef: PropTypes.shape({}),
  account: PropTypes.shape({ accessToken: PropTypes.string }),
  adblock: PropTypes.bool,
  anonymousId: PropTypes.string,
  anonymousLogin: PropTypes.func,
  authSuccess: PropTypes.bool,
  blackoutConfig: PropTypes.shape({}),
  blackoutDefinitions: PropTypes.shape({}),
  breakpoint: PropTypes.string.isRequired,
  clearNextVideosValidFor: PropTypes.func.isRequired,
  clearPercentWatched: PropTypes.func.isRequired,
  clearTimeout: PropTypes.func,
  clearVideo: PropTypes.func.isRequired,
  coordinates: PropTypes.shape({}),
  countdownVideo: PropTypes.shape({}),
  deviceId: PropTypes.string,
  disableRender: PropTypes.bool.isRequired,
  errors: PropTypes.shape({}),
  favoritesManager: PropTypes.shape({
    favorites: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setFavorites: PropTypes.func.isRequired,
    deleteFavorites: PropTypes.func.isRequired,
  }),
  fetchUpNext: PropTypes.func.isRequired,
  fetchVideo: PropTypes.func.isRequired,
  forceCollectionKeyartForShowcase: PropTypes.func.isRequired,
  getUseUtagGlobal: PropTypes.func.isRequired,
  hasSeenHalfAnyVideo: PropTypes.bool,
  hideVideoUntilPlayback: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool,
  isHeader: PropTypes.bool,
  isHomePage: PropTypes.bool,
  isLiveRestart: PropTypes.bool,
  isLivePage: PropTypes.bool,
  isMiniPlayerActive: PropTypes.bool,
  isNavScheduleRendered: PropTypes.bool,
  isPlayerLoaded: PropTypes.bool,
  isStatic: PropTypes.bool,
  isVodUnavailable: PropTypes.bool,
  location: PropTypes.shape({}),
  mvpdData: PropTypes.shape({}),
  nextVideos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  nextVideosValidFor: PropTypes.number,
  onAuthCheckComplete: PropTypes.func,
  onChannelSelect: PropTypes.func,
  openSignIn: PropTypes.func,
  openSignUp: PropTypes.func,
  optimizely: PropTypes.shape({}),
  optimizelyResults: PropTypes.shape({}),
  originalItem: PropTypes.shape({}),
  page: PropTypes.string,
  pageViewEvent: PropTypes.func.isRequired,
  playNextPlaylistVideo: PropTypes.func.isRequired,
  playerType: PropTypes.string,
  panels: PropTypes.shape({
    itemsPerPage: PropTypes.number,
    member: PropTypes.arrayOf(PropTypes.shape({})),
    totalItems: PropTypes.number,
  }),
  panelVideo: PropTypes.shape({}),
  params: PropTypes.shape({ videoId: PropTypes.string }),
  playerContext: PropTypes.string,
  playlistData: PropTypes.shape({}),
  portalRef: PropTypes.string,
  preauthorizedResources: PropTypes.arrayOf(PropTypes.string),
  profileId: PropTypes.string,
  provider: PropTypes.shape({}),
  recommendationIdData: PropTypes.oneOfType([PropTypes.node, PropTypes.shape({})]),
  reducerVideo: PropTypes.shape({}),
  releaseUrl: PropTypes.string,
  renderAuthContainer: PropTypes.func.isRequired,
  renderVideoContainer: PropTypes.func,
  resetVodSectionClicked: PropTypes.func.isRequired,
  restartVideo: PropTypes.shape({}),
  retryErrors: PropTypes.shape({}),
  seo: PropTypes.shape({}),
  setAccountCloseIgnoreRedirect: PropTypes.func,
  setAuthorizationToken: PropTypes.func.isRequired,
  setBlockMVPDIncomplete: PropTypes.func,
  setHasSeenHalfAnyVideo: PropTypes.func,
  setInterval: PropTypes.func,
  setIsAuthenticated: PropTypes.func,
  setIsPlayerLoaded: PropTypes.func,
  setLoading: PropTypes.func,
  setMiniPlayerActive: PropTypes.func,
  setMVPDLogoutDataToAppState: PropTypes.func,
  setMVPDToAppState: PropTypes.func,
  setOverlay: PropTypes.func,
  setProvider: PropTypes.func.isRequired,
  setRecommendationId: PropTypes.func,
  setTimeout: PropTypes.func,
  setVideoPanel: PropTypes.func.isRequired,
  setVideoStartedPlayback: PropTypes.func.isRequired,
  shouldResetStillWatching: PropTypes.bool,
  startedPlayback: PropTypes.bool.isRequired,
  streamExit: PropTypes.bool,
  toggleMvpdAuthOverlay: PropTypes.func,
  triggerAuthCheck: PropTypes.bool,
  video: PropTypes.shape({}),
};
